/**
 * @file index.tsx
 *
 * @fileoverview Shows an empty box placeholder for the map section of organizations.
 */

import React from 'react';
import { useIntl } from 'react-intl';
import { OrganizationEmptyBoxPlaceholder } from '~/jobiqo/components/Organization/Widgets/OrganizationBoxPlaceholder';
import { OrganizationProfile } from '~/jobiqo/types/types';
import { Box } from '~/vcl/atoms/07-box';
import { AddIcon } from '~/vcl/icons/Add';
import { MapMarkerIcon } from '~/vcl/icons/MapMarker';

interface OrganizationLocationsWidgetEmptyProps {
  /**
   * The current resume.
   */
  organization: OrganizationProfile;
  /**
   * The current box id.
   */
  boxId: string;
}

export const OrganizationLocationsWidgetEmpty = ({
  organization,
  boxId,
}: OrganizationLocationsWidgetEmptyProps) => {
  const intl = useIntl();
  return (
    <Box>
      <OrganizationEmptyBoxPlaceholder
        organization={organization}
        field={boxId}
        text={intl.formatMessage({
          id: 'organization_map_empty_text',
          defaultMessage: `Enter additional office locations here. This will give the candidates a map overview of every location
                your organization is located on.`,
        })}
        buttonText={intl.formatMessage({
          id: 'organization_map_empty_enter',
          defaultMessage: `Enter locations`,
        })}
        multiple={true}
        icon={<MapMarkerIcon title="Map" />}
        buttonIcon={<AddIcon title="map" />}
      />
    </Box>
  );
};
